/**
 * Single-open disclosure for an accordion section.
 *
 * Each section in the Accordion component carries its own `accordion` scope, so
 * the open question is tracked per-section: opening a question closes any other
 * open question in the same section, while questions in sibling sections are
 * left untouched ( separate `x-data` scopes don't share state ).
 *
 * `active` holds the index of the open question within this section, or null
 * when every question is collapsed.
 *
 * Usage ( emitted by template-parts/components/accordion.php ):
 *   <div x-data="accordion">
 *     <h4>
 *       <button @click="toggle( 0 )" :aria-expanded="isOpen( 0 ).toString()"
 *               :class="{ 'is-open': isOpen( 0 ) }">…</button>
 *     </h4>
 *     <div x-show="isOpen( 0 )" x-collapse>…</div>
 *   </div>
 */

document.addEventListener( 'alpine:init', () => {

	Alpine.data( 'accordion', () => ({

		// Index of the open question in this section, or null when all closed.
		active: null,

		isOpen( index ) {
			return this.active === index;
		},

		toggle( index ) {
			this.active = this.active === index ? null : index;
		},

	}) );
});
